import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { DRAWER_TYPES } from 'utils/constants';

import BlockRoundedIcon from '@mui/icons-material/BlockRounded';

// Context
import { DrawerContext } from 'common/drawer/DrawerContext';

// The wizards
import Wizard from 'common/Wizard';

// Helpers
import { setDialogDetails } from 'feature/loading-management/supplier-authorizations/store/supplierAuthorizationSlice';
import { resetCarrierAuthWizardData } from 'feature/loading-management/carrier-authorizations/store/createNewCarrierAuthSlice';
import allCarrierAuthSteps from 'feature/loading-management/carrier-authorizations/create-new-steps/Steps';

const NoAuthorizedCarriers = () => {
  const { setDrawerComponentProps } = useContext(DrawerContext);
  const { pathname } = useLocation();
  const routePath = pathname.split('/');
  const viewBy = routePath[5];

  const handleOnClick = () =>
    setDrawerComponentProps({
      Component: props => (
        <Wizard steps={allCarrierAuthSteps} title="New Carrier Authorizations" {...props} />
      ),
      forceCloseSelector: state => state.loadingManagement.createNewCarrierAuth.forceClose,
      holdOpenSelector: state => state.loadingManagement.createNewCarrierAuth.submittingBatch,
      // when on carrier auth and you open the wizard from the + button here
      // closing resets to default state for authorization by, but when
      // on carrier auth and reopening the drawer the default may not be the correct
      // authorization by for the wizard to get the correct prefilled data for the
      // dropdown in the detail step
      resetWizard: () =>
        pathname.includes('carrier-authorizations')
          ? resetCarrierAuthWizardData(viewBy)
          : resetCarrierAuthWizardData(),
      setCurrentDialogOpen: () =>
        setDialogDetails({
          header: 'Are you sure you want to close the wizard?',
          message:
            'By closing the wizard you will no longer be able to view the progress of each activation however, all requests will continue until complete. Please confirm you want to close the wizard.',
        }),
      type: DRAWER_TYPES.createNewCarrierAuth,
    });

  return (
    <Box bgcolor="graphic.lighter" borderRadius={0.5} mt={{ md: '33px' }}>
      <Box alignItems="center" display="flex">
        <BlockRoundedIcon
          sx={{
            color: 'graphic.main',
            fontSize: 20,
            px: 2,
            py: 0,
          }}
        />
        <Typography
          component="p"
          sx={{
            color: 'rgba(0,0,0,0.6)',
            m: 2,
            ml: 0,
          }}
          variant="body2"
        >
          There are no authorized carriers for your selected affiliate.
          <br />
          Go
          <Button
            onClick={handleOnClick}
            sx={{ height: 14, minWidth: 36, pb: 0, pt: '2px', px: 0 }}
            variant="text"
          >
            here
          </Button>
          to authorize carriers to view Carrier Performance and BOL History
        </Typography>
      </Box>
    </Box>
  );
};

export default NoAuthorizedCarriers;
